const fallbackHandle = '@socs_sup366';
const configuredHandle = import.meta.env.VITE_TELEGRAM_HANDLE || fallbackHandle;
const normalizedHandle = configuredHandle.startsWith('@') ? configuredHandle.slice(1) : configuredHandle;

export const contactInfo = {
  telegramHandle: configuredHandle,
  telegramUrl: import.meta.env.VITE_TELEGRAM_URL || `https://t.me/${normalizedHandle || 'socs_sup366'}`,
};
